import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/topicEndManage',
  redirect: 'noredirect',
  name: 'topicEndManage',
  component: Layout,
  children: [
    {
      path: 'topicEndManage',
      component: () => import('@/views/topicEndManage/index.vue'),
      name: 'topicEndManage',
      meta: {
        title: '结题管理',
        icon: 'equiptype',
        requireAuth: true
      }
    }]
}

export default equipRouter
